import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { SelectLayout } from '@blazar-plugins/device'
import { bindActionCreators } from 'redux'
import queryString from 'query-string'
import { actionCreators as classifiedActionCreators } from 'reduxBits/classified'
import { actionCreators as searchParamsActionCreators } from 'reduxBits/searchParams'
import { actionCreators as accountActionCreators, errorTypes } from 'reduxBits/account'
import SaveErrorModal from 'components/SaveErrorModal'
import MediumLayout from './MediumLayout'
import SmallLayout from './SmallLayout'

const mapStateToProps = (state, ownProps) => ({
  parameters: state.searchParams.activeParameters,
  haveSearchResults: state.classified.searchResults.searchTotal > 0,
  searchTotal: state.classified.searchResults.searchTotal,
  currentQuery: queryString.parse(ownProps.location.search),
  errorType: state.account.adWatches.errorType,
  sellerTypeParameter: state.searchParams.activeParameters.find(
    (parameter) => parameter.dataGroup === 'seller_types',
  ),
  sortOrderParameter: state.searchParams.activeParameters.find(
    (parameter) => parameter.dataGroup === 'sort_orders',
  ),
})

const mapDispatchToProps = (dispatch) => ({
  classifiedActions: bindActionCreators(classifiedActionCreators, dispatch),
  searchParamsActions: bindActionCreators(searchParamsActionCreators, dispatch),
  accountActions: bindActionCreators(accountActionCreators, dispatch),
})

const FilterSave = (props) => {
  const { searchParamsActions } = props

  const handleChange = useCallback(
    (e, queryKey, value) => {
      // If the value is empty string, set it to undefined
      // so that the redux action removes it from the query
      const _value = value === '' ? undefined : value
      searchParamsActions.select({ [queryKey]: _value })
    },
    [searchParamsActions],
  )

  const { errorType, accountActions } = props
  const hasMaxSavedError = errorType === errorTypes.MAX_ADWATCHES_ERROR

  return (
    <>
      <SelectLayout
        layouts={{
          medium: () => <MediumLayout {...props} handleChange={handleChange} />,
          small: () => <SmallLayout {...props} handleChange={handleChange} />,
        }}
      />
      {hasMaxSavedError && (
        <SaveErrorModal
          title="Det gick inte att spara bevakningen"
          text="Du har uppnått gränsen för antal sparade bevakningar (20&nbsp;st). Om du vill spara den här bevakningen måste du först ta bort en annan."
          onClose={accountActions.resetAdWatchError}
          hrefToSaved="/sparade"
          savedButtonText="Ändra bevakningar"
        />
      )}
    </>
  )
}

/* eslint-disable react/no-unused-prop-types */
/**
 * All are used but the rule can't handle when the props are spread
 * in a function
 */
FilterSave.propTypes = {
  haveSearchResults: PropTypes.bool,
  searchResultDescription: PropTypes.node,
  searchTotal: PropTypes.number.isRequired,
  parameters: PropTypes.array.isRequired,
  classifiedActions: PropTypes.objectOf(PropTypes.func).isRequired,
  searchParamsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  accountActions: PropTypes.objectOf(PropTypes.func).isRequired,
  location: PropTypes.object.isRequired,
  currentQuery: PropTypes.object.isRequired,
  device: PropTypes.any,
  sellerTypeParameter: PropTypes.object,
  sortOrderParameter: PropTypes.object,
  errorType: PropTypes.string,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterSave)
